import styled from "styled-components";

export const InteractionPaneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #606060;
`;

export const CallVehicleButtonStyled = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 102px;
  gap: 8px;
  background: #3f7f7d;
  font-size: 20px;
  color: #ffffff;
  border: none;
  cursor: pointer;

  &:disabled {
    border: none;
    cursor: not-allowed;
    background: #d6d8de;
    color: #606060;

    svg {
      path {
        stroke: #606060;
      }
    }
  }
`;

export const EmptyErrorStyled = styled.div`
  color: red;
  font-weight: 500;
`;

export const MapViewStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-items: center;
  border: 2px solid #377f70;
  padding: 24px 0;
  color: #377f70;
  font-size: 20px;
  cursor: pointer;
`;
